import { useState } from 'react';

const usePagination = (data: any[], itemsPerPage: number) => {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(data.length / itemsPerPage);

    const nextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    const prevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const resetPage = () => {
        setCurrentPage(1);
    };

    const currentData = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return data.slice(startIndex, startIndex + itemsPerPage);
    };

    return {
        currentPage,
        totalPages,
        itemsPerPage,
        nextPage,
        prevPage,
        resetPage,
        currentData,
    };
};

export default usePagination;